<template>
  <figure class="box">
    <a :href="backgroundImage" :data-size="imageSize">
      <img
        :data-src="`background:url(${backgroundImage});`"
        :src='backgroundImage'
      />
    </a>
  </figure>
</template>

<script>
export default {
  props: {
    imageSize: {
      type: String,
      default: "1920x1280"
    },
    backgroundImage: {
      type: String,
      required: true
    }
  },
  computed: {
    width() {
      return this.imageSize.split('x')[0] + 'px';
    },
    height() {
      return this.imageSize.split('x')[1] + 'px';
    },
  },
};
</script>
